export const START_REQUEST = "START_CARDS_REQUEST";
export const END_REQUEST = "END_CARDS_REQUEST";
export const GET_CARDS = "GET_CARDS";
export const ADD_CARD = "ADD_CARD";
export const EDIT_CARD = "EDIT_CARD";